// @flow

import fuzzysearch from 'fuzzysearch';
import { deburr, isEmpty, sortBy, takeWhile, toLower, uniqBy } from 'lodash';

import type { ServiceLike } from '@zapier/services/src/types';

const POPULARITY_RANK_EFFECT = 2;

const serviceScorer = (query: string) => (service: ServiceLike) => {
  const { name, title, categories, popularity } = service;
  const nameOrTitle = deburr(toLower(name || title || ''));
  const category = toLower((categories && categories.join(' ')) || '');
  const isByZapier = nameOrTitle.includes('by zapier');

  let score = 0;

  // Score by title
  if (nameOrTitle === query) score += 100;
  else if (nameOrTitle.includes(query) && isByZapier) score += 60;
  else if (nameOrTitle.includes(query)) score += 50;
  else if (fuzzysearch(query, nameOrTitle.toLowerCase())) score += 10;

  // Score by category
  if (category === query) score += 50;
  else if (category.includes(query) && isByZapier) score += 30;
  else if (category.includes(query)) score += 25;
  else if (fuzzysearch(query, category)) score += 5;

  // Factor in popularity
  if (popularity) score *= 1 + POPULARITY_RANK_EFFECT / popularity;

  return score;
};

export const getServiceTitle = (service: ServiceLike) =>
  service && (service.name || service.title);

const search = (query: string, services: Array<ServiceLike>) => {
  const cleanQuery = query && deburr(query.trim().toLowerCase());
  if (isEmpty(cleanQuery)) {
    return services;
  }

  const scorer = serviceScorer(cleanQuery);
  const sorted = uniqBy(sortBy(services, scorer).reverse(), getServiceTitle);
  const results = takeWhile(sorted, scorer);

  return results;
};

export default search;
